import { Select } from '@iqueue/ui-kit'
import NodePresenter from '../../api/nodePresenter'
import { useCallback, useRef } from 'react'
import useTranslate, { t } from '../../hooks/useTranslate'

export default function PickNode({
  name = 'nodeId',
  current,
  value,
  onChange,
  hidden,
  ...props
}) {

  const cache = useRef()

  const render = useCallback((id) => {
    const item = cache.current.indexed[id]

    return {
      id: id,
      title: item?.name,
      subtitle: t(`type.node.${ item?.type }`),
      disabled: id === current?.id,
    }
  }, [t, current])

  const fetchData = useCallback(() => {
    return NodePresenter.readIndexed(cache)
  }, [])

  const handleSelectChange = useCallback((id) => {
    onChange(id)
  }, [])

  return <Select
    name={ name }
    entries={ fetchData }
    render={ render }
    value={ value }
    allowSearch
    onChange={ handleSelectChange }
    hidden={ current?.type === 'ORGANIZATION' || hidden }
    { ...props }
  />
}
